<template>
    <div class="container-fluid" v-if="Object.keys(vehicle).length">
        <h4>{{ vehicle.make.name }} {{ vehicle.model.name }}
            <app-vehicle-no :slug="vehicle.slug"/>
            , {{ vehicle.reg_no }}
            <router-link v-if="$store.getters.canEditVehicles"
                         :to="{name: 'vehicles.edit', params: {vehicle_id: vehicle.id}}"
                         class="btn btn-primary btn-sm text-white float-right">
                {{ $t('Edit') }}
            </router-link>
            <router-link :to="{name:'booking.create', query: {vehicle: vehicle.id}}" class="btn btn-sm btn-success text-white float-right ml-2">
                {{ $t('Book') }}
            </router-link>
        </h4>
        <div class="clearfix"></div>
        <div class="row">
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Make') }}</label>
                    <p class="custom-gray-input-bg">{{ vehicle.make.name }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Model') }}</label>
                    <p class="custom-gray-input-bg">{{ vehicle.model.name }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Reg no') }}</label>
                    <p class="custom-gray-input-bg">{{ vehicle.reg_no }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Year') }}</label>
                    <p class="custom-gray-input-bg">{{ vehicle.year }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Year') }}</label>
                    <p class="custom-gray-input-bg">{{ vehicle.user_year }}</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('VIN') }}</label>
                    <p class="custom-gray-input-bg">{{ vehicle.vin }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Drivetrain') }}</label>
                    <p class="custom-gray-input-bg">{{ $t(vehicle.drivetrain.name) }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Type') }}</label>
                    <p class="custom-gray-input-bg">{{ $t(vehicle.type.name) }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Fuel') }}</label>
                    <p class="custom-gray-input-bg">{{ $t(vehicle.fuel.name) }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Transmission') }}</label>
                    <p class="custom-gray-input-bg">{{ $t(vehicle.transmission.name) }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Color') }}</label>
                    <p class="custom-gray-input-bg">{{ vehicle.color[locale] }}</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Group') }}</label>
                    <p class="custom-gray-input-bg">{{ vehicle.group ? vehicle.group.name[locale] : '' }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Body type') }}</label>
                    <p class="custom-gray-input-bg">{{ vehicle.body_type[locale] }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Engine') }}</label>
                    <p class="custom-gray-input-bg">{{ vehicle.engine }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Odometer') }}</label>
                    <p class="custom-gray-input-bg">{{ vehicle.odometer }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Liability') }}</label>
                    <p class="custom-gray-input-bg">{{ vehicle.liability_sum / 100 }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Bond') }}</label>
                    <p class="custom-gray-input-bg">{{ vehicle.bond / 100 }}</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Equipment') }}</label>
                    <p class="custom-gray-input-bg">{{ vehicle.equipment[locale] }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Damages') }}</label>
                    <p class="custom-gray-input-bg">{{ vehicle.damages[locale] }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Comments') }} {{ $t('(in house)') }}</label>
                    <p class="custom-gray-input-bg">{{ vehicle.comments }}</p>
                </div>
            </div>
        </div>
        <hr v-if="vehicle.imgs && vehicle.imgs.length">
        <div class="row" v-if="vehicle.imgs.length">
            <div class="col">
                <h4>{{ $t('Images') }}</h4>
                <div v-for="(file, i) in vehicle.imgs" :key="i" class="float-left" style="position: relative">
                    <span v-if="$store.getters.canDeleteVehicles" class="mdi mdi-24px mdi-trash-can-outline trash-img" @click="destroyImg(file.id, i)"/>
                    <img :src="`${envUrl}/vehicles/${file.dbname}`"
                         width="160px"
                         height="auto"
                         class="img-thumbnail"
                         :class="{'ml-2':i > 0}"/>
                </div>
            </div>
        </div>
        <div v-if="vehicle.pricelists && vehicle.pricelists.length && $store.getters.canEditPrices">
            <hr>
            <div class="row">
                <div class="col">
                    <h4>{{ $t('Prices') }}</h4>
                    <validation-observer v-slot="{ validate }" slim>
                        <form @submit.prevent="updateDiscountDates(validate)">
                            <div class="row mb-3  d-flex align-bottom">
                                <div class="col-2">
                                    <app-datepicker id="discount_start_at"
                                                    v-model="discount_form.discount_start_at"
                                                    name="discount_start_at">
                                        <template #label>
                                            {{ $t('Start') }}
                                        </template>
                                    </app-datepicker>
                                </div>
                                <div class="col-2">
                                    <app-datepicker id="discount_end_at"
                                                    v-model="discount_form.discount_end_at"
                                                    name="discount_end_at">
                                        <template #label>
                                            {{ $t('End') }}
                                        </template>
                                    </app-datepicker>
                                </div>
                                <div class="col-2">
                                    <div class="pt-4">
                                        <app-button :loading="loading" small>
                                            {{ $t('Update') }}
                                        </app-button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </validation-observer>
                    <app-pricelist v-for="(pricelist, i) in vehicle.pricelists" :pricelist="pricelist" :key="i"/>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div v-if="bookings.length">
                    <hr>
                    <div class="row">
                        <div class="col">
                            <h4>{{ $t('Booking history') }}</h4>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="table-responsive">
                                <table class="table table-sm table-striped">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>{{ $t('Pick up & return') }}</th>
                                            <th>{{ $t('Price') }}</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(booking, i) in bookings" :key="i">
                                            <td>{{ i + 1 }}</td>
                                            <td>
                                                {{ booking.pickup_location.name[locale] }} - {{ booking.return_location.name[locale] }}
                                                <br>
                                                {{ booking.start_time | formatDateTime }} - {{ booking.end_time | formatDateTime }}
                                            </td>
                                            <td>{{ (booking.prices.total / 100).toFixed() }}€</td>
                                            <td class="p-0">
                                                <div class="text-right">
                                                    <router-link v-if="$store.getters.canViewContracts"
                                                                 :to="{name: 'booking.show', params: {booking_id: booking.id}}"
                                                                 class="btn btn-info btn-sm text-white mt-2">
                                                        {{ $t('View') }}
                                                    </router-link>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div v-if="contracts.length">
                    <hr>
                    <div class="row">
                        <div class="col">
                            <h4>{{ $t('Contract history') }}</h4>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="table-responsive">
                                <table class="table table-sm table-striped">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>{{ $t('Pick up & return') }}</th>
                                            <th>{{ $t('Price') }}</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(contract, i) in contracts" :key="i">
                                            <td>{{ i + 1 }}</td>
                                            <td>
                                                {{ contract.pickup_location.name[locale] }} - {{ contract.return_location.name[locale] }}
                                                <br>
                                                {{ contract.start_time | formatDateTime }} - {{ contract.end_time | formatDateTime }}
                                            </td>
                                            <td>{{ (contract.prices.total / 100).toFixed() }}€</td>
                                            <td class="p-0">
                                                <div class="text-right">
                                                    <router-link v-if="$store.getters.canViewContracts"
                                                                 :to="{name: 'contracts.show', params: {contract_id: contract.contract.id}}"
                                                                 class="btn btn-info btn-sm text-white mt-2">
                                                        {{ $t('View') }}
                                                    </router-link>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VehicleService from '@services/vehicle.service';
import {mapGetters} from 'vuex';
import {fixDate} from '@services/helper.service';

export default {
    data() {
        return {
            vehicle: {},
            contracts: [],
            bookings: [],
            loading: false,
            discount_form: {
                discount_start_at: null,
                discount_end_at: null
            }
        };
    },
    computed: {
        ...mapGetters(['envUrl', 'locale'])
    },
    methods: {
        updateDiscountDates(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    VehicleService.updateDiscountDates(this.$route.params.vehicle_id, this.discount_form).then(res => {
                        this.$toastr.s(this.$t('Updated'));
                        this.loading = false;
                    }).catch(e => {
                        this.loading = false;
                    });
                }
            });
        },
        getVehicle(vehicleId) {
            VehicleService.show(vehicleId).then(res => {
                this.vehicle = res.vehicle;
                this.contracts = res.contracts;
                this.bookings = res.bookings;
                this.discount_form = {
                    discount_start_at: res.vehicle.discount_start_at ? fixDate(res.vehicle.discount_start_at) : null,
                    discount_end_at: res.vehicle.discount_end_at ? fixDate(res.vehicle.discount_end_at) : null
                };
            });
        },
        destroyImg(imgId, index) {
            if (!window.confirm(`${this.$t('Delete')}?`)) {
                return false;
            }
            VehicleService.destroyImg(imgId).then(() => {
                this.vehicle.imgs.splice(index, 1);
                this.$toastr.s(this.$t('Deleted'));
            });
        },
    },
    created() {
        this.getVehicle(this.$route.params.vehicle_id);
    }
};
</script>
